(ns teamoesterreich.admin-mode.lebensretter.lr-user.modal.qualification-modal
  (:require [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.data.lr-clearance :as d-lrClearance]
            [teamoesterreich.element.backend-file :as backend-file]
            [teamoesterreich.util.log :as log]))

(def REGIONS (txt/txt :fake :lr-regions))

(defn parse-date [date]
  ;(log/debug "parse date" date)
  (js/Date.parse (if date (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)) "1970")))

(defn date-conv [date]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  ;(log/debug "date-conv " date)
  (let [d (js/Date. (if (and (not (nil? date)) (> (count (str date)) 12)) (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)) "1970"))
        y (.getFullYear d)
        m (inc (.getMonth d))
        m (if (> m 9) m (str "0" m))
        d (.getDate d)
        d (if (> d 9) d (str "0" d))]
    (str y "-" m "-" d))
  )
(defn date-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" "120000.000Z"))



(defn date-conv-add [date add-years]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  ;(log/debug "date-conv " date)
  (if (and (not (nil? date)) (> (count (str date)) 12))
    (str (+ (parse-long (subs date 0 4)) add-years) "-" (subs date 4 6) "-" (subs date 6 8)
         )
    (let [now (js/Date.)
          m (inc (.getMonth now))
          m (if (> m 9) m (str "0" m))
          d (.getDate now)
          d (if (> d 9) d (str "0" d))]
      (str (+ add-years (.getFullYear now)) "-" m "-" d))
    ))




(defn modal [!actual-user !show]
  (let [!invalidate (r/cursor vstate/app-state [:lr-list :invalidate])
        !loaded (r/cursor vstate/app-state [:lr-list :loaded])
        lrClearance (:user-lrClearance @!actual-user)
        {:keys [user-uuid user-lastName user-firstName]} @!actual-user
        !st (r/atom {:changed?                          false
                     :lrClearance-qualification-until   (date-conv (:lrClearance-qualification-until lrClearance))
                     :lrClearance-qualification-message (:lrClearance-qualification-message lrClearance)})
        training-doc (:lrClearance-trainingDocument lrClearance)]
    (fn []
      (let [!lrClearance-qualification-message (r/cursor !st [:lrClearance-qualification-message])
            date-to-ok? (and (:lrClearance-qualification-until @!st)
                             (< (.getTime (new js/Date)) (js/Date. (:lrClearance-qualification-until @!st))))]
        [mui/modal
         {
          :aria-labelledby  "simple-modal-title"
          :aria-describedby "simple-modal-description"
          :style            {:display        "flex"
                             :marginRight    "auto"
                             :marginLeft     "auto"
                             :alignItems     "center"
                             :justifyContent "center"}
          :open             (or @!show false)

          }


         [:div
          {
           :class "modal"
           :style {:width 750}}
          [mui/grid {:container  true
                     :direction  "row"
                     :justify    "space-between"
                     :alignItems "flex-start"}
           [mui/grid {:container false :item true :xs 12}
            [:h2 "Lebensretter Qualifikation für `" user-firstName " " user-lastName "` bestätigen!"]

            [mui/grid {:container  true
                       :direction  "row"
                       :justify    "space-between"
                       :spacing    2
                       :style      {:paddingRight "5px"}
                       :alignItems "flex-start"}
             (when (:userDocument-fileName training-doc)
               [mui/grid {:container false :item true :xs 6}
                [:h4 "Als Qualifikationdokument: " [:br] "Dokument gültig bis : " (date-conv (:userDocument-validTo training-doc))]

                ])
             (when (:userDocument-fileName training-doc)
               [mui/grid {:container false :item true :xs 6}
                [:f> backend-file/download-wrapper (:userDocument-path training-doc)
                 (fn [url]
                   (let [url (when url (js/URL. url))]
                     (when url
                       (.set (.-searchParams url) "inline" "true"))
                     [:a {:title "Klick um in neuem Tab zu öffnen"
                          :href  url :target "_blank"}
                      [:div {:style {:position "relative" :float "right"}} (:userDocument-fileName training-doc)] [:br]
                      [backend-file/img {:hash     (:userDocument-path training-doc)
                                         :preview? true
                                         :style    {:position "relative" :float "right" :width "100%" :maxWidth "400px" :maxHeight "600px" :objectFit "contain"} :alt "Ansicht"}]
                      ]))]


                [:br]
                [:br]
                [:br]
                ])
             [mui/grid {:container false :item true :xs 12}
              (if (:userDocument-fileName training-doc) "Optionale Begründung" "Begründung für Freigabe ohne Dokument")]
             [mui/grid {:container false :item true :xs 12 :style {:margin-bottom "30px"}}
              [mui/text-field {
                               :style           {:background-color (if (not= "" @!lrClearance-qualification-message) "#ffd6d2" "#ffffff")}
                               :fullWidth       true
                               :type            "text"
                               :error           (= "" @!lrClearance-qualification-message)
                               :multiline       true
                               :rowsMin         3
                               :placeholder     "Z.B.: Auszug aus dem Mitarbeiterakt"
                               :helper-text     (if (= "" @!lrClearance-qualification-message) "Bitte Begründung eingeben" "")
                               :onChange        (fn [e] (reset! !lrClearance-qualification-message (h/event-value e)))
                               :label           (str "Begründung")
                               :defaultValue    (str "" @!lrClearance-qualification-message)
                               :InputLabelProps {:disableAnimation true :shrink true}
                               }]
              ]
             ]

            ]

           [mui/grid {:container false :item true
                      :xs        12
                      :style     {:padding "5px 0 15px 0"}}

            [:span [:br] "Gültigkeit von Qualifikationen 5 Jahre ab Ausstellung"]]

           [mui/grid {:container false :item true
                      :xs        6
                      :style     {}}
            [mui/text-field {
                             :style           {:background-color (if (not= (:lrClearance-qualification-until @!st) (:lrClearance-qualification-until lrClearance)) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :type            "date"
                             :autoOk          true
                             :onChange        (fn [e] (swap! !st assoc :lrClearance-qualification-until (h/event-value e)))
                             :label           (str "Qualifikation gültig bis ")
                             :value           (:lrClearance-qualification-until @!st)
                             :InputLabelProps {:disableAnimation true :shrink true}
                             }]]

           [mui/grid {:container false :item true :xs 12 :style {:paddingTop "5px"}}
            [mui/button {:size    "small"
                         :variant "contained"
                         :onClick (fn []
                                    (let [now (js/Date.)
                                          newDate (date-conv-add (str (.getFullYear now) "-" (inc (.getMonth now)) "-" (.getDate now)) 5)]
                                      (swap! !st assoc :lrClearance-qualification-until newDate)))
                         }
             "jetzt + 5 Jahre"]
            ]


           [mui/grid {:container false :item true :xs 12} [:div " " [:br] " " [:br]]]




           [mui/grid {:container false :item true :xs 6}
            [mui/button
             {:variant   "contained"
              :startIcon (r/as-element [keyboard-arrow-left])
              :style     {:marginRight 50}
              :onClick   #(reset! !show false)
              }
             "Abbrechen"]]

           [mui/grid {:container false :item true :xs 6}
            ;(log/debug "löllöl date-to-ok?" date-to-ok? " " @!lrClearance-qualification-message)
            (when (and (not= "" (str @!lrClearance-qualification-message)) date-to-ok?)
              [mui/button
               {:color     "primary"
                :style     {:float "right"}
                :variant   "contained"
                :startIcon (r/as-element [save])
                :onClick   (fn [] (d-lrClearance/>user-add-edit-clearance (:user-uuid @!actual-user)
                                                                          (merge {:lrClearance-qualification-until   (date-conv-back (:lrClearance-qualification-until @!st))
                                                                                  :lrClearance-qualification-message @!lrClearance-qualification-message
                                                                                  :lrClearance-qualification-valid   true
                                                                                  })
                                                                          (fn []
                                                                            (d-user/actual-user-invalidate !actual-user)
                                                                            (reset! !invalidate true)
                                                                            (reset! !loaded nil)
                                                                            (reset! !show false))
                                                                          ))
                }
               "Bestätigen"]
              )]
           ]]]
        ))))





(defn get-user-details [!actual-user tomId]
  (d-user/get-user-all tomId (fn [data] (reset! !actual-user data)))
  )

(defn modal-by-tomId [!tomId]
  (let [!actual-user (r/atom {})]
    (fn []
      (let [user @!actual-user
            tomId @!tomId]
        (js/console.log "render qualification modal-by-tomId " tomId)
        (when (and (pos? tomId) (not= tomId (:reqTomId user)))
          (get-user-details !actual-user tomId))

        (if (or (not= @!tomId (:reqTomId user))
                (:error user))
          ;no data
          [mui/modal
           {:aria-labelledby  "simple-modal-title"
            :aria-describedby "simple-modal-description"
            :style            {:display        "flex"
                               :marginRight    "auto"
                               :marginLeft     "auto"
                               :alignItems     "center"
                               :justifyContent "center"}
            :open             (pos? tomId)
            :onClose          (fn []
                                (reset! !actual-user {})
                                (reset! !tomId nil))
            }
           [:div
            {:class "modal"
             :style {:width 400}}

            [:h4 (str "Qualifikation bestätigen: " tomId)]
            [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
            [mui/typography "Lade den Datensatz ... "]
            [mui/typography {:color "primary"} (:error user)]
            [:br]
            [mui/button
             {:color    "primary"
              :variant  "contained"
              :on-click (fn []
                          (reset! !actual-user {})
                          (reset! !tomId {}))
              }
             "Schließen"]
            ]]
          ;has data
          (modal !actual-user !tomId)

          )
        ))))